import { render, staticRenderFns } from "./qnaAnalytics.vue?vue&type=template&id=34908bd5"
import script from "./qnaAnalytics.vue?vue&type=script&lang=js"
export * from "./qnaAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports